import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import CountUp from 'react-countup';

const founders = {
//   sumeiya: {
//     key: 'sumeiya',
//     name: 'Sumeiya Ahmed AlKizim',
//     title: 'Founder & Marketing Lead',
//     experience: '10+ Years',
//     specialization: 'Brand Strategy & Integrated Marketing',
//     image: '',
//     story: `HYPE was born from a clear conviction: world-class branding, events, and marketing should not be reserved for a privileged few. In a market where creativity was often locked behind high costs and rigid systems, Sumeiya set out to remove barriers and reimagine access.

// With a deep understanding of brand strategy, consumer behavior, and market dynamics, she built HYPE to bridge creativity, technology, and execution—empowering startups, SMEs, and corporates alike to compete without compromise.

// Her leadership is rooted in empowerment and collaboration. A strong advocate for women in business and technology, she has shaped HYPE into a people-first organization where teams thrive and brands scale with confidence.`,
//     philosophy:
//       'Creativity only matters when it is accessible, intentional, and results-driven. Impact comes from clarity, not noise.'
//   },

  mugambi: {
    key: 'mugambi',
    name: 'Mugambi Muthuri',
    title: 'Co-Founder & Creative Lead',
    experience: '7+ Years',
    specialization: 'Creative Strategy & Experiential Design',
    image: '/assets/images/hero/denis.jpg',
    story: `Mugambi is the creative architect behind HYPE’s visual identity and experiential work. Trained as an architect and software engineer, he brings structure, systems thinking, and storytelling together to redefine how brands engage audiences.

His journey began with a desire to challenge rigid industry norms—where creativity was constrained by limited access and outdated processes. He envisioned a space where ideas could move freely, collaboration was central, and creativity drove growth.

As Creative Lead, he oversees brand strategy, design, and event execution, ensuring every output is insight-led, culturally relevant, and engineered for impact.`,
    philosophy:
      'Design is not decoration. It is communication, structure, and intent working together to create meaning and measurable results.'
  }
};

const achievements = [
  { icon: 'Users', label: 'Brands Served', value: 20, suffix: '+' },
  { icon: 'Briefcase', label: 'Industries Covered', value: 12, suffix: '+' },
  { icon: 'Map', label: 'Regional Reach', value: 'East Africa' },
  { icon: 'Sparkles', label: 'Integrated Services', value: 'End-to-End' }
];


export default function FounderStory() {
  const [activeFounder, setActiveFounder] = useState('mugambi');
  const [showQuickNav, setShowQuickNav] = useState(false);

  const founderList = Object.values(founders);
  const founder = founders[activeFounder];

  useEffect(() => {
    document.body.style.overflow = showQuickNav ? 'hidden' : '';
    return () => (document.body.style.overflow = '');
  }, [showQuickNav]);

  return (
    <>
    <section data-theme="light" className="relative py-2">
      
      {/* ================= MOBILE HEADER ================= */}
      <div className="lg:hidden text-center mb-6">
        <div className="inline-flex items-center gap-2 bg-accent/10 px-4 py-1 rounded-full mb-3">
          <Icon name="User" size={16} className="text-accent" />
          <span className="text-xs font-semibold text-accent">Founders</span>
        </div>

        <h2 className="text-2xl font-bold text-primary">
          The Minds Behind <span className="text-accent">HYPE</span>
        </h2>

        <button
          onClick={() => setShowQuickNav(true)}
          className="mt-4 inline-flex items-center gap-2 bg-accent text-white px-5 py-2 rounded-md text-sm font-semibold"
        >
          Switch Founder
          <Icon name="ChevronUp" size={16} />
        </button>
      </div>

      {/* ================= MOBILE CARD ================= */}
      <div className="lg:hidden bg-surface rounded-2xl p-6 shadow-subtle space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-xl overflow-hidden bg-gray-100">
            {founder.image && (
              <Image
                src={founder.image}
                alt={founder.name}
                className="w-full h-full object-cover"
              />
            )}
          </div>

          <div>
            <h3 className="text-lg font-bold text-primary">{founder.name}</h3>
            <p className="text-sm text-text-secondary">{founder.title}</p>
            <p className="text-xs text-text-secondary">{founder.experience}</p>
          </div>
        </div>

        <div className="text-sm leading-relaxed text-text-primary space-y-4">
          {founder.story.split('\n\n').map((p, i) => {
            const [firstWord, ...rest] = p.split(' ');
            return (
              <p key={i}>
                <span className="font-semibold text-base mr-1">{firstWord}</span>
                {rest.join(' ')}
              </p>
            );
          })}
        </div>

        <div className="border-l-4 border-accent pl-4 italic text-sm text-text-secondary">
          “{founder.philosophy}”
          <div className="mt-2 font-semibold">{founder.name}</div>
        </div>
      </div>

      {/* ================= DESKTOP LAYOUT ================= */}
      <div className="hidden lg:grid grid-cols-2 gap-16 items-center">
        {/* CONTENT */}
        <div className="space-y-4">
          {/* TOGGLE */}
          <div className="flex gap-6 mb-8">
            {founderList.map(f => (
              <button
                key={f.key}
                onClick={() => setActiveFounder(f.key)}
                className={`px-6 py-3 rounded-full font-semibold transition ${activeFounder === f.key
                  ? 'bg-accent text-white'
                  : 'bg-surface text-text-secondary hover:bg-surface/70'
                  }`}
              >
                {f.name.split(' ')[0]}
              </button>
            ))}
          </div>

          <div>
            <h2 className="text-4xl font-bold text-primary mb-2">
              The Minds Behind <span className="text-red-600 text-5xl">HYPE</span>
            </h2>

            <div className="flex gap-3 text-text-secondary">
              <span className="font-semibold text-red-600">{founder.name}</span>
              <span className="text-red-600">•</span>
              <span>{founder.title}</span>
              <span className="text-red-600">•</span>
              <span>{founder.experience}</span>
            </div>
          </div>

          <div className="text-lg max-w-prose space-y-6 leading-relaxed">
            {founder.story.split('\n\n').map((p, i) => {
              const [firstWord, ...rest] = p.split(' ');
              return (
                <p key={i}>
                  <span className="text-xl mr-1 font-semibold">{firstWord}</span>
                  {rest.join(' ')}
                </p>
              );
            })}
          </div>

          <div className="bg-surface p-6 rounded-xl border-l-4 border-accent">
            <Icon name="Quote" size={32} className="text-accent mb-4" />
            <p className="text-lg italic mb-4">{founder.philosophy}</p>
            <p className="font-semibold">{founder.name}</p>
            <p className="text-sm text-text-secondary">{founder.title}</p>
          </div>

          <div className="grid grid-cols-2 gap-8">
              {achievements.map((a, i) => (
                <div key={i} className="text-center p-6 bg-white rounded-xl shadow-subtle">
                  <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-2 shadow-subtle">
                    <Icon name={a.icon} size={22} className="text-accent" />
                  </div>
                  <p className="text-2xl font-bold">
                    {typeof a.value === 'number' ? (
                      <CountUp end={a.value} duration={2.5} suffix={a.suffix ?? ''} />
                    ) : (
                      a.value
                    )}
                  </p>
                  <p className="text-sm text-text-secondary">{a.label}</p>
                </div>
              ))}
            </div>
        </div>

        {/* IMAGE */}
        <div className="space-y-10">
          {/* IMAGE + BADGE */}
          <div className="relative max-w-lg mx-auto">
            <div className="w-full rounded-2xl overflow-hidden shadow-elevation">
              <Image
                src={founder.image}
                alt={founder.name}
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Badge */}
            <div className="absolute -bottom-5 -right-4 bg-accent text-white p-4 rounded-xl shadow-elevation">
              <Icon name="Camera" size={28} strokeWidth={2} />
            </div>
          </div>

          {/* PERSONAL MISSION */}
          <div className="bg-black-red-oscillate text-white p-6 sm:p-8 rounded-xl max-w-lg mx-auto border-l-4 border-accent">
            <Icon name="Quote" size={32} className="text-accent mb-4" />
            <h3 className="text-lg sm:text-2xl text-white font-bold mb-4">
              Our <span className="text-red-600">Company</span> Statement
            </h3>

            <p className="text-white/90 mb-4 leading-relaxed text-sm sm:text-base">
              “Every project is an opportunity to push the boundaries of what's possible
              in the corporate world. We don't just capture moments — we engineer
              experiences that resonate long after the final frame.”
            </p>

            {/* <div className="flex items-center gap-3">
              <Icon name="Heart" size={18} color="#D4AF37" strokeWidth={2} />
              <span className="text-accent font-semibold text-sm sm:text-base">
                Passion for Perfection
              </span>
            </div> */}
          </div>
        </div>
        </div>

      
    </section>
    <div className="fixed inset-0 z-[9999] lg:hidden pointer-events-none">
        <aside
          className={`
            pointer-events-auto
            absolute inset-x-0 bottom-0
            bg-white
            rounded-t-3xl
            shadow-2xl
            transition-transform duration-300
            ${showQuickNav ? 'translate-y-0' : 'translate-y-full'}
          `}
        >
          <div className="p-4">
            <div className="flex justify-center mb-3">
              <div className="h-1.5 w-12 bg-gray-300 rounded-full" />
            </div>

            <div className="flex justify-between mb-4">
              <span className="font-semibold text-sm">Select Founder</span>
              <button onClick={() => setShowQuickNav(false)}>Close</button>
            </div>

            <div className="space-y-2 max-h-[60vh] overflow-y-auto">
              {founderList.map(f => (
                <button
                  key={f.key}
                  onClick={() => {
                    setActiveFounder(f.key);
                    setShowQuickNav(false);
                  }}
                  className={`w-full p-3 rounded-lg text-left ${
                    activeFounder === f.key
                      ? 'bg-accent/10 text-accent'
                      : 'hover:bg-surface'
                  }`}
                >
                  {f.name}
                </button>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </>
  );
}
